import { handleActions } from "redux-actions";
import { GET_USER_PERMISSIONS } from "../constants";

export const permissions = handleActions(
    {
        [GET_USER_PERMISSIONS]: (state, action) => {
            // console.log(action.payload);
            return action.payload.filter(p => p.state === 1 || p.state === true).map(r => r.permission)
        }
    }, []
)